module.exports = __webpack_public_path__ + "images/_/_/shared/images/barcode_reader/barcode-frame_767f65b2e1b1c81c9e470078bdfcf996.png";